/** Series colors, named so a card's presentation list can ask for one. */
export const SERIES_COLORS = {
    // Tableau 10.
    blue: "#4E79A7",
    orange: "#F28E2B",
    red: "#E15759",
    teal: "#76B7B2",
    green: "#59A14F",
    yellow: "#EDC948",
    purple: "#B07AA1",
    pink: "#FF9DA7",
    brown: "#9C755F",
    gray: "#BAB0AC",
    // Ten more in Tableau's lightness range, each picked to sit furthest from those before it.
    plum: "#9B3C67",
    periwinkle: "#8C9CF8",
    olive: "#626A14",
    violet: "#704EA4",
    cerulean: "#1AA1C9",
    lavender: "#7F78D3",
    salmon: "#D0897D",
    mustard: "#977E0D",
    mauve: "#906486",
    brick: "#B04945",
} as const;

/**
 * The order streams take the colors in, twenty before any repeats: Tableau 10 in its own order, then
 * the ten picked to go with it. Worst pair (OKLab ΔE×100, normal vision / red-green colorblind) is
 * 15/12 within the first four and 8/1 from ten on, the 1 being Tableau's own red and green.
 */
export const SERIES_PALETTE: readonly string[] = Object.values(SERIES_COLORS);

const colorKey = (color: string) => color.toLowerCase();

/**
 * The hue fewest streams on the card have so far, earliest in the order on a tie. Counts what it
 * picks in `useCounts`, keyed by lowercase hex, which a card's listed colors seed. Past the end of
 * the palette the hues come round again.
 */
export function nextSeriesColor(useCounts: Map<string, number>): string {
    const count = (color: string) => useCounts.get(colorKey(color)) ?? 0;
    const color = SERIES_PALETTE.reduce((least, candidate) => (count(candidate) < count(least) ? candidate : least));

    countSeriesColor(useCounts, color);
    return color;
}

export function countSeriesColor(useCounts: Map<string, number>, color: string): void {
    useCounts.set(colorKey(color), (useCounts.get(colorKey(color)) ?? 0) + 1);
}
